import { useEffect, useRef, useState } from 'react';

export const usePopoverPosition = (submenuWidth = 288) => {
  const popoverRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<'right' | 'left'>('right');
  const RIGHT_PADDING = 96;

  useEffect(() => {
    const updatePosition = () => {
      if (!popoverRef.current) {
        return;
      }
      const rect = popoverRef.current.getBoundingClientRect();
      const spaceOnRight = window.innerWidth - rect.right - submenuWidth - RIGHT_PADDING;
      setPosition(spaceOnRight > 0 ? 'right' : 'left');
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);
    return () => window.removeEventListener('resize', updatePosition);
  }, [submenuWidth]);

  return { popoverRef, position };
};
